import { Model } from '../../../shared/models/model';
import { Expose, Type } from 'class-transformer';
import { Media } from '../../shared-features/models/media.model';
import { DeliveryNoteType } from '@shared-features/enums/delivery-note-type.enum';

export class ShipmentDeliveryNote extends Model {
  @Expose()
  id: number;

  @Expose()
  referenceNumber: number;

  @Type(() => Media)
  @Expose()
  attachment: Media = new Media();

  @Expose()
  shipment_id: number;

  @Expose()
  updatedByName: string;

  @Expose()
  updatedAt: string;

  @Expose()
  uploadedAt: Date;

  @Expose()
  type: DeliveryNoteType;
}
